(function () {
  'use strict';

  const Clients = window.AAHeadquartersClients;
  if (!Clients || !Clients.prototype || Clients.prototype.__aaCatalogSaveReliability) return;

  const prototype = Clients.prototype;
  const originalBindClientActions = prototype.bindClientActions;

  // The Clients interface can be rendered before its other independent
  // services have finished loading. Bind delegated actions first, so a
  // form cannot submit natively while those services are still pending.
  prototype.init = async function () {
    this.bindClientActions();
    this.bindTaskAnchorActions();
    this.bindNewClientForm();

    await this.loadClients();

    // Deep links can open directly to the Catalogs tab without another click.
    if (this.activeClientTab === 'catalogs' && this.activeClientId) {
      await this.refreshCatalogHistoryFromServer(this.activeClientId);
    }

    const results = await Promise.allSettled([
      this.loadActiveClientPlaybooks(),
      this.loadActiveClientPackage(),
      this.loadActiveClientTaskAnchors(),
      this.loadActiveClientAccess(),
      this.loadActiveClientBrandWorkspace(),
      this.loadActiveClientContracts(),
      this.loadWaveConnection(),
      this.loadActiveClientWaveMapping(),
      this.loadCatalogDeletionPermissions()
    ]);

    results.forEach((result, index) => {
      if (result.status === 'rejected') {
        console.warn('Headquarters client service failed to initialize:', index, result.reason);
      }
    });

    // Never rebuild a live catalog form here. Re-rendering replaces the
    // file input and silently discards the PDF the user just selected.
    const editingCatalog = Boolean(this.addingCatalogClientId || this.editingCatalogId);
    if (!editingCatalog) this.render();
  };

  prototype.refreshCatalogHistoryFromServer = async function (clientId) {
    if (!clientId || !window.AASupabaseClient?.getCatalogRecords) return;
    const token = (this.__aaCatalogRefreshToken || 0) + 1;
    this.__aaCatalogRefreshToken = token;

    try {
      const records = await window.AASupabaseClient.getCatalogRecords({ clientId });
      if (!Array.isArray(records)) {
        throw new Error('Catalog history returned an invalid result');
      }
      if (this.__aaCatalogRefreshToken !== token) return;
      const client = this.clients.find(item => String(item.id) === String(clientId));
      if (!client) return;
      client.catalog_records = records;

      // Do not destroy a partially completed upload form by re-rendering.
      const formOpen = String(this.addingCatalogClientId || '') === String(clientId) ||
        Boolean(this.editingCatalogId);
      if (String(this.activeClientId) === String(clientId) && !formOpen) {
        this.render();
      }
    } catch (error) {
      console.warn('Catalog history refresh failed:', error);
      if (String(this.activeClientId) === String(clientId)) {
        this.showStatusMessage('Catalog history could not refresh. Saved catalogs have not been deleted.', 'error');
      }
    }
  };

  if (typeof originalBindClientActions === 'function') {
    prototype.bindClientActions = function () {
      originalBindClientActions.call(this);
      this.root.addEventListener('click', event => {
        const tab = event.target.closest?.('[data-aa-client-tab]');
        if (tab?.dataset.aaClientTab !== 'catalogs') return;
        const clientId = this.activeClientId;
        const client = this.clients.find(item => String(item.id) === String(clientId));
        if (!client || (Array.isArray(client.catalog_records) && client.catalog_records.length)) return;
        void this.refreshCatalogHistoryFromServer(clientId);
      });
    };
  }

  Object.defineProperty(prototype, '__aaCatalogSaveReliability', {
    value: true, enumerable: false
  });
})();